export class VerifyOtpRequest {
    otpId: string;
    otp: string;
    mode: string = "web";
}


// WEBPACK FOOTER //
// ./src/app/shared/otp/verify-otp-request.ts